import { put, race, take, takeLatest } from 'redux-saga/effects';

import * as cancelInvitation from '../requests/cancel-invitation-to-virtual-room-req';
import * as success from '../../ui/success';
import * as error from '../../ui/error';

function* cancelInvitationWorker() {
  const { succeed, failed } = yield race({
    succeed: take(cancelInvitation.actions.succeed),
    failed: take([
      cancelInvitation.actions.rejected,
      cancelInvitation.actions.errorEncountered,
    ]),
  });

  if (succeed) {
    yield put({
      type: success.consts.UPDATE,
      payload: { id: 'virtualVisit.room.invitationRemoved' },
    });
  }

  if (failed) {
    yield put({
      type: error.consts.UPDATE,
      payload: { id: 'errors.common' },
    });
  }
}

export default function* cancelInvitationSaga() {
  yield takeLatest(cancelInvitation.actions.send, cancelInvitationWorker);
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/cancel-invitation-to-virtual-visit-saga.js